import React from 'react';
import { useDispatch } from 'react-redux';

import { AddBoldIcon, FilePlusIcon } from 'app/components/shared/icons';
import useBehavioral, { BEHAVIORALS } from 'hooks/useBehavioral';
import { setShowResourceSubmissionModal } from 'store/reducers/resource-submission/resource-submission-reducer';

import { ResourcesSubmitMobileTitle, ResourcesSubmitMobileWrapper } from './styled';

export default function ResourcesSubmitMobile() {
  const dispatch = useDispatch();
  const resourceCreateCTAClickedBehavioralFunction = useBehavioral(
    BEHAVIORALS.RESOURCE_CREATE_CTA_CLICKED
  );

  const handleClick = () => {
    resourceCreateCTAClickedBehavioralFunction();
    dispatch(setShowResourceSubmissionModal(true));
  };

  return (
    <ResourcesSubmitMobileWrapper onClick={handleClick}>
      <FilePlusIcon fill="var(--color-primary)" width={20} height={20} />
      <ResourcesSubmitMobileTitle>SUBMIT A RESOURCE</ResourcesSubmitMobileTitle>
    </ResourcesSubmitMobileWrapper>
  );
}
